import React, { Component } from 'react';
import {localization} from '../../Frames/localization'

import {materialThemeField} from '../../../src/App'
import { ThemeProvider } from "@material-ui/styles";

import MessageWindow from '../../Elements/Snackbar/MessageWindow'
import {messageWindow} from '../../Elements/Snackbar/MessageWindow'

import Label from '../../Elements/Label/labels'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from "../../Elements/Button/buttons";
import TableCardLimits from '../../Elements/Table/tableCardLimits'
import {SelectCard,SelectPurse} from '../../Elements/Select/selectCardlimits'
import InputText from "../../Elements/TextField/InputText";
import { Divider } from '@material-ui/core';
import { AppliedSettings } from '../../App';

class CardLimits extends Component 
{
    render()
    {   const {data} = this.props.res;
        return(
            <Paper className="cardlimitsBox">
                {data.subAccounts &&
                <TableCardLimits data={data} className="cardlimitsTable"></TableCardLimits>
                }
            </Paper>
        );
    }
}

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")
}
class SetLimits extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            res: this.props.res,
            day: "",
            week: "",
            month: "",
            dayAmount: "",
            weekAmount: "",
            monthAmount: "",
            subAccountId: "",

            disabled: {
                day: false,
                week: false,
                month: false,
            },
        };
        this.onChangeday = this.onChangeday.bind(this);
        this.onChangeweek = this.onChangeweek.bind(this);
        this.onChangemonth = this.onChangemonth.bind(this);
        //this.selectfirstPurse = this.selectfirstPurse.bind(this);

        this.onSelectCard = this.onSelectCard.bind(this)
        this.onSelectPurse = this.onSelectPurse.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }
    appliedDisabled(data)
    {
        switch(data)
        {
            case 0: return {day: true, week: true, month: true};
            case 1: return {day: false, week: true, month: true};
            case 2: return {day: true, week: false, month: true};
            case 3: return {day: true, week: true, month: false};
            case 4: return {day: false, week: false, month: true};
            case 5: return {day: false, week: true, month: false};
            case 6: return {day: true, week: false, month: false};
            case 7: return {day: false, week: false, month: false};
        }
    }
    componentDidMount()
    {
        this.setState({
            day: this.props.res.data.limitDay !== null? this.props.res.data.limitDay:"",
            week: this.props.res.data.limitWeek !== null? this.props.res.data.limitWeek:"",
            month: this.props.res.data.limitMonth !== null? this.props.res.data.limitMonth:"",
            dayAmount: this.props.res.data.limitDayAmount !== null? this.props.res.data.limitDayAmount:"",
            weekAmount: this.props.res.data.limitWeekAmount !== null? this.props.res.data.limitWeekAmount:"",
            monthAmount: this.props.res.data.limitMonthAmount !== null? this.props.res.data.limitMonthAmount:"",
            subAccountId: this.props.res.data.subAccountId,
            disabled: this.appliedDisabled(AppliedSettings.limits_enable)
        });       
    }
    onSubmit(event)
    {
        this.props.asyncDisabledTrue();
        var data = {
            limitDay: document.getElementById('day').value,
            limitWeek: document.getElementById('week').value,
            limitMonth: document.getElementById('month').value,
            subAccountId: this.state.subAccountId
        }
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        }
        fetch(`/alterLimits`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({key: Math.random()})
            }
             return response.json()})
        .then((response) => {
            if(response.error == null)
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("success", localization.GetTranslate(response.data))
                this.setState({
                    keyMessage: Math.random(),
                });    
                this.props.componentDidMount()
                this.forceUpdate()
            }else
            {
                this.props.asyncDisabledFalse();
                messageWindow.OpenMessage("error", localization.GT(response.error))
                this.setState({keyMessage: Math.random()})
            }
        })
        this.forceUpdate()
        event.preventDefault();
    }
    onChangemonth(event){
        this.setState({month: event.target.value});
      }
    onChangeweek(event){
        this.setState({week: event.target.value});
      }
      onChangeday(event) {
        this.setState({day: event.target.value});
      }
      onSelectCard(value)
    {
            const url =`/api/getlimits?card=` + value; 
            fetch(url, requestOptionsExit)
            .then((response) => response.json())
            .then((response) => {
                    this.setState({res: response,
                    day: response.data.limitDay !== null? response.data.limitDay:"",
                    week: response.data.limitWeek !== null? response.data.limitWeek:"",
                    month: response.data.limitMonth !== null? response.data.limitMonth:"",
                    dayAmount: response.data.limitDayAmount !== null? response.data.limitDayAmount:"",
                    weekAmount: response.data.limitWeekAmount !== null? response.data.limitWeekAmount:"",
                    monthAmount: response.data.limitMonthAmount !== null? response.data.limitMonthAmount:"",
                    subAccountId: response.data.subAccountId
                });
            })
            this.setState({key: Math.random()})
            this.forceUpdate();
    }
    onSelectPurse(value, card)
    {
            const url =`/api/getlimits?card=`+card+`&subAccountId=`+value; 
            fetch(url, requestOptionsExit)
            .then((response) => response.json())
            .then((response) => {
                this.setState({res: response,
                    day: response.data.limitDay !== null? response.data.limitDay:"",
                    week: response.data.limitWeek !== null? response.data.limitWeek:"",
                    month: response.data.limitMonth !== null? response.data.limitMonth:"",
                    dayAmount: response.data.limitDayAmount !== null? response.data.limitDayAmount:"",
                    weekAmount: response.data.limitWeekAmount !== null? response.data.limitWeekAmount:"",
                    monthAmount: response.data.limitMonthAmount !== null? response.data.limitMonthAmount:"",
                    subAccountId: response.data.subAccountId
                });
            })
            this.forceUpdate();
    }
   /* selectfirstPurse(subId,subIds)
    {   
        var id = undefined;
        subIds.map(item => {
            if(subId==item.id)
            {
                return id = item.id;
            }
        })
        return id;
    }*/
    render()
    {
        const {data} = this.state.res;
        var {day,week,month,dayAmount,weekAmount,monthAmount,disabled} = this.state;
        var tr = {
            Card: localization.GetTranslate('Limits.Card'),
            Purse: localization.GetTranslate('Limits.Purse'),
            Daylimit: localization.GetTranslate('Limits.Day limit'),
            Weeklimit: localization.GetTranslate('Limits.Week limit'),
            Monthlimit: localization.GetTranslate('Limits.Month limit'),
            Change: localization.GetTranslate('buttons.Change'),
            Written: localization.GetTranslate('Limits.Written off bonuses')
        }
        return(
            <Paper className="setlimitsBox">
                <MessageWindow key={this.state.keyMessage} ></MessageWindow> 
                <form onSubmit={this.onSubmit}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={"auto"}>
                        <div className="blockSelectCard">
                        <ThemeProvider theme={materialThemeField}>
                            <SelectCard value={data.card.externalCode} onSelectCard={this.onSelectCard} textLabel={tr.Card} data={data} className="selectCard" classNamelabel="selectCardLabel"></SelectCard>
                            <SelectPurse value={this.state.subAccountId} key={this.state.key} onSelectPurse={this.onSelectPurse} textLabel={tr.Purse} data={data} className="selectCard" classNamelabel="selectCardLabel"></SelectPurse>
                        </ThemeProvider>
                        </div>
                    </Grid>
                </Grid>
                <Divider />
                <br></br>
                <Grid container justify="center" spacing={0.2}>
                    <Grid item xs={"auto"}>
                        <InputText 
                            disabled={disabled.day}
                            id="day"
                            name="day"
                            onChange={this.onChangeday}
                            value={day}
                            inputProps={{min: 0}}
                            type="number"
                            label={tr.Daylimit}
                            margin="normal"
                            variant="outlined"
                            className="InputLimits"
                            classNamelabel="InputLimitsLabel"
                            />
                    </Grid>
                    <Grid item xs={"auto"}>    
                        <InputText id="week"
                            disabled={disabled.week}
                            name="week"
                            onChange={this.onChangeweek}
                            value={week}
                            inputProps={{min: 0}}
                            type="number"
                            label={tr.Weeklimit}
                            margin="normal"
                            variant="outlined"
                            className="InputLimits"
                            classNamelabel="InputLimitsLabel"/>
                    </Grid>
                    <Grid item xs={"auto"}> 
                        <InputText id="month"
                            disabled={disabled.month}
                            name="month"
                            onChange={this.onChangemonth}
                            value={month}
                            inputProps={{min: 0}}
                            type="number"
                            label={tr.Monthlimit}
                            margin="normal"
                            variant="outlined"
                            className="InputLimits"
                            classNamelabel="InputLimitsLabel"/>
                    </Grid>
                </Grid>
                {this.props.AppliedSettings.limits_statistics_view &&
                <Grid container justify="center" spacing={0.2}>
                    <Grid item xs={"auto"}>
                        <div className="labelAmount"> 
                            <Label textLabel={tr.Written+": "+dayAmount} ></Label>
                        </div>
                    </Grid>
                    <Grid item xs={"auto"}>   
                        <div className="labelAmount">  
                            <Label textLabel={tr.Written+": "+weekAmount} className="labelAmount" ></Label>
                        </div>
                    </Grid>
                    <Grid item xs={"auto"}> 
                        <div className="labelAmount"> 
                            <Label textLabel={tr.Written+": "+monthAmount} className="labelAmount"></Label>
                        </div>
                    </Grid>
                </Grid>
                }
                <br></br>
                <Divider />
                <Button
                    variant="contained"
                    type="submit"
                    value="submit"
                    color="primary"
                    textLabel={tr.Change}
                    className="SaveButtonLimits"
                    disabled={this.props.asyncDisabled}
                >
                </Button> 
                </form>
            </Paper>
        );
    }
}

export { CardLimits, SetLimits };